import React from 'react';
import { Collapse } from '@mui/material';

import { useAppSelector } from '../hooks';
import { OnShowDownloadPopupParams } from '../RootComponent';
import AlertBox from '../tools/AlertBox';
import { ControlBar } from './ControlBar';
import CreateJob from './CreateJob';
import JobManagement from './JobManagement';
import Views from './views/Views';

interface Props {
  onShowDownloadPopup: (params: OnShowDownloadPopupParams) => void;
  onShowDownloadGridPopup: () => void;
  onShowFileManagerPopup: (fileManagerPopup: React.ReactNode) => void;
  closePopup: () => void;
}

export default function Controls(props: Props) {
  const { onShowDownloadPopup, onShowDownloadGridPopup, onShowFileManagerPopup, closePopup } = props;
  const activeControl = useAppSelector((state) => state.jobs.activeControl);

  const controlPanel =
    activeControl === 'create' || activeControl === 'edit' ? (
      <CreateJob
        onShowFileManagerPopup={onShowFileManagerPopup}
        onShowDownloadPopup={onShowDownloadPopup}
        closePopup={closePopup}
      />
    ) : activeControl === 'views' ? (
      <Views />
    ) : activeControl === 'manageJobs' ? (
      <JobManagement />
    ) : null;

  return (
    <>
      <div>
        <ControlBar onShowDownloadGridPopup={onShowDownloadGridPopup} />
        <Collapse in={activeControl !== null} mountOnEnter unmountOnExit>
          {controlPanel}
        </Collapse>
      </div>
      <div>
        <AlertBox />
      </div>
    </>
  );
}
